<template>
  <div class="social-accounts">
    <div class="social-accounts__state">
      <span class="social-accounts__label" v-html="`${$t('account')[account.type]}:&nbsp;`" />
      <span class="social-accounts__value">
        {{ account.email }}
      </span>
    </div>
    <div class="social-accounts__action">
      <a
        class="social-accounts__link"
        :class="canUnlink ? '' : 'social-accounts__link--disabled'"
        data-test="unlinkSocialAccount"
        @click="showUnlinkForm"
      >
        {{ $t("remove")[account.type] }}
      </a>
      <info-tooltip class="social-accounts__info-tooltip" :text="$t('tooltip')[account.type]" />
    </div>
  </div>
</template>

<script>
import InfoTooltip from "@/shared/info-tooltip"
/**
 * @emits unlink-social-account
 */
export default {
  name: "SocialAccount",
  components: { InfoTooltip },
  props: {
    account: {
      type: Object,
      required: true
    },
    canUnlink: Boolean
  },
  methods: {
    showUnlinkForm() {
      if (this.canUnlink) {
        this.$emit("unlink-social-account", this.account)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        account: {
          apple: "Apple",
          facebook: "Facebook"
        },
        remove: {
          apple: 'Remove "Sign in with Apple"',
          facebook: 'Remove "Sign in with Facebook"'
        },
        tooltip: {
          apple:
            'Before you can remove "Sign in with Apple", you need to link your account to an email address and password below.',
          facebook:
            'Before you can remove "Sign in with Facebook", you need to link your account to an email address and password below.'
        }
      },
      de: {
        account: {
          apple: "Apple",
          facebook: "Facebook"
        },
        remove: {
          apple: '"Mit Apple anmelden" entfernen',
          facebook: '"Mit Facebook anmelden" entfernen'
        },
        tooltip: {
          apple:
            'Um "Mit Apple anmelden" zu entfernen musst du deinem Konto zuerst eine E-Mail-Adresse und ein Passwort hinzufügen.',
          facebook:
            'Um "Mit Facebook anmelden" zu entfernen musst du deinem Konto zuerst eine E-Mail-Adresse und ein Passwort hinzufügen.'
        }
      }
    }
  }
}
</script>

<style lang="scss">
.social-accounts {
  @include font-style(p);

  margin-bottom: $spacing-32;

  &__state {
    display: flex;
    flex-direction: column;
    margin-bottom: $spacing-8;

    @include media(min-width, m) {
      flex-direction: row;
      margin-bottom: 0;
    }
  }

  &__action {
    display: flex;
    align-items: center;
  }

  &__label {
    @include font-style(h5, $color: $mid-grey);
  }

  &__label,
  &__value {
    @include media(max-width, m) {
      display: block;
    }
  }

  &__info-tooltip {
    margin-left: $base;
  }

  &__link {
    cursor: pointer;

    &--disabled {
      color: $light-grey;

      cursor: auto;

      &:hover {
        color: $light-grey;
      }
    }
  }
}
</style>
